/**
 * Shared score ramp / floating-tag / gold-tracker drain timing for run results.
 * Matches {@link RampingNumberText} when passed
 * `duration={RUN_RESULTS_SCORE_RAMP_BASE_MS}`,
 * `durationScaleReferenceValue={RUN_RESULTS_SCORE_RAMP_REFERENCE_DELTA}`,
 * `minScaledDuration={RUN_RESULTS_SCORE_RAMP_MIN_MS}`.
 */
export const RUN_RESULTS_SCORE_RAMP_BASE_MS = 1040

/** Scale factor: effective ms = base × (|score Δ| / this), then clamped. */
export const RUN_RESULTS_SCORE_RAMP_REFERENCE_DELTA = 20

export const RUN_RESULTS_SCORE_RAMP_MIN_MS = 200

/**
 * Same scaling as `RampingNumberText` duration scaling: full `baseMs` when |Δ| ≥ reference
 * (after the min/base clamps), shorter ramps for smaller point transfers.
 */
export function scaleRunResultsScoreRampDurationMs(
  scoreDelta: number,
  baseMs: number = RUN_RESULTS_SCORE_RAMP_BASE_MS,
): number {
  const baseDur = Math.max(0, baseMs)
  if (!(baseDur > 0)) {
    return 0
  }

  const scaleRef = RUN_RESULTS_SCORE_RAMP_REFERENCE_DELTA
  if (!(scaleRef > 0) || !Number.isFinite(scaleRef)) {
    return baseDur
  }

  const d = Math.abs(scoreDelta)
  let rampDur = baseDur * (d / scaleRef)
  rampDur = Math.max(RUN_RESULTS_SCORE_RAMP_MIN_MS, rampDur)
  rampDur = Math.min(baseDur, rampDur)
  return rampDur
}
